import React, { useState } from 'react'
import context from '@/context'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import {
  BsrsGrid,
  EnumFilterCell,
  EnumCell,
  actionButtonsColumnProps,
  BooleanColumn
} from '@/components/BsrsGrid'
import { Main, MainTop, MainTopTitle, MainBody, MainTopLeft } from '@/components/Layout'
import Resx from '@/components/Resx'
import { workflowDefinitionType } from '@/enums/workflowDefinitionType'
import { Button } from '@/components/button'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import Icon from '@/components/Icon'
import moment from 'moment'
import { useLocalization } from '@/hooks/localization'
import { useDispatch } from '@/hooks/dispatch'
import { WorkflowVersionCell } from '@/components/BsrsGrid/BsrsGrid.WorkflowVersionCell'

const WorkflowDefinitionList = function WorkflowDefinitionList (props) {
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())
  const { localize } = useLocalization()
  const [openDialog] = useDispatch([dialogActions.openDialog])

  const refresh = () => setLastReloadedAt(moment())

  const dialogSuccess = () => {
    openDialog({
      dialogType: dialogTypes.alert,
      content: 'Common.WorkflowSaved',
      title: 'Common.Success'
    })
  }

  const dialogFail = (item) => {
    if (item && item.response && item.response.data) {
      openDialog({
        dialogType: dialogTypes.validationErrors,
        errorInfo: item.response.data.error
      })
    } else {
      openDialog({
        dialogType: dialogTypes.alert,
        content: 'Common.SavingWorkflowFailed',
        title: 'Common.Failure'
      })
    }
  }

  const onAddClick = () => {
    openDialog({
      dialogType: dialogTypes.addWorkflowVersion,
      onAction: (item) => {
        context.api.workflowDefinitionService.saveDefinition(item)
          .then(() => {
            refresh()
            dialogSuccess()
          })
          .catch(result => dialogFail(result))
      }
    })
  }

  const enumName = workflowDefinitionType.enumName
  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Common.WorkflowConfigurations' /></MainTopTitle>
        <MainTopLeft>
          <Button color='primary' className='btn btn-md' onClick={onAddClick}>
            <Icon name='plus' />
            <Resx name={'Common.Add'} />
          </Button>
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <BsrsGrid
          persistenceId={'workflow-definition-list'}
          dataSource={context.api.workflowDefinitionService.getWorkflowDefinitionTableData}
          lastReloadedAt={lastReloadedAt}
          filterable>
          <Column field='code' title={localize('Common.Code')} editable={false} />
          <Column field='name' title={localize('Common.ArabicName')} editable={false} />
          <Column field='latinName' title={localize('Common.LatinName')} editable={false} />
          {BooleanColumn({ field: 'allowManualExecution', title: localize('Common.AllowManualExecution'), editable: false })}
          <Column field='version' cell={WorkflowVersionCell()} title={localize('Common.Version')} editable={false} filterable={false} />
          <Column field='workflowDefinitionType' title={localize('Common.WorkflowDefinitionType')} cell={EnumCell({ localize, enumName })}
            filterCell={EnumFilterCell({ localize, enumName }, workflowDefinitionType.values)}
            enumName={enumName} editable={false} />
          <Column {...actionButtonsColumnProps(dataItem => [{
            url: x => `/workflow-configuration/${x.id}`,
            icon: 'show'
          }])} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
}

export { WorkflowDefinitionList }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/workflow-configuration/list.js